import { all, call, put, select } from 'redux-saga/effects'
import { hideLoading, showLoading } from 'react-redux-loading-bar'

import { selectors as TranslationSelectors } from '../../redux/i18n/redux'
import app from '../../config/app'
import routes, { Router } from '../../routes'
import { actions as AppActions } from '../../redux/app/redux'

import { actions } from './redux'


export default class UserValidateSepaSagas {

  static* init(ctx) {
    yield put(showLoading())

    yield put(actions.setIsValid(true))

    const seo = yield call(UserValidateSepaSagas.transformSeo)

    yield all([
      yield put(AppActions.setSeo(seo)),
      yield put(actions.setLoaded(true)),
      yield put(hideLoading()),
    ])

    return {}
  }

  static* transformSeo() {
    const i18nLang = yield select(TranslationSelectors.lang)
    const i18nStore = yield select(TranslationSelectors.store)
    const titleLabel = i18nStore[i18nLang].translation.SEO_user_validate_sepa_title
    const descriptionLabel = i18nStore[i18nLang].translation.SEO_user_validate_sepa_description

    const seoProps = {
      title: titleLabel,
      image: '',
      description: descriptionLabel,
      url: `${app.APP_URL}${Router.getRouteUrl(routes.userValidateSepa)}`,
      noindex: true,
    }

    return seoProps
  }

  static* loop() {
    yield all([
    ])
  }

}
